export const title="Quality Management System";